import script from "./PanelAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./PanelAction.vue?vue&type=script&setup=true&lang=ts"

import "./PanelAction.vue?vue&type=style&index=0&id=14e047f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e047f0"]])

export default __exports__